export default {
  page: {
    upc: 'UPC',
    standardPrice: `Jessica's Standard Price`,
    minPrice: 'Global Min Price',
    maxPrice: 'Global Max Price',
    exportProductData: 'Download the prouct data',
    searchPlaceHolder: 'Enter Search Conditon',
    clearancePrice: 'Clearance Price',
    discount: 'Discount',
    taxfreePrice: 'Tax-free Price',
    viewPriceTrend: 'View price trend',
    expandAll: 'Load All',
    collapseAll: 'Unfold',
    // 一级表格字段
    tableColumns: {
      shopName: 'Comparison Shop Name',
      retailPrice: 'Retail Price',
      cur: 'Cur.',
      retp: 'Ret-p({0})',
      optp: 'Dis-price({0})',
      promoRate: 'Discount in %',
      differenceTo: 'Difference to({0})',
      indexTo: 'Index to({0})',
      priceGrading: 'Price Grading',
      status: 'Status',
    },
    // 二级展开表格字段
    comparesTableColumns: {
      retailPrice: 'Retail Price',
      cur: 'Cur.',
      retp: 'Ret-p({0})',
      optp: 'opt-p({0})',
      status: 'Status',
      code: 'Code',
    },
    // 图表
    charts: {
      avgPrice: 'Avg price',
    },

    // 提示
    tips: {
      notParams: '{0} params error!',
    },
  },
  priceTrend: {
    title: 'Price Trend',
    monntoredShop: 'Monitored Shops',
    favoriteShop: 'Favorite Shops',
    subText: 'Submit',
    cancelText: 'Cancel',
    noDataMsg: "The selected shop doesn't offer this price type, please choose other price types.",
    chartTable: {
      name: 'Name',
      price: 'Price',
      difference: 'Difference',
      differenceRatio: 'Difference Ratio',
    },
    selectShopMoadl: {
      title: 'Monitored Shops',
      label: 'Monitored Shops',
      subText: 'Submit',
      cancleText: 'Cancel',
    },
    priceBox: 'All Price',
    priceType: 'Price Type',
    offlinePrice: 'Cashback Price',
    onSalePrice: 'On Sale Price',
    priceAfterBestDiscount: 'Price After Best Discount',
    original: 'Retail Price',
    retailerDisPrice: 'Retailer Dis-Price',
    state: {
      all: 'All',
      onShelf: 'Launched',
      offShelf: 'Removed',
      sellOut: 'Sold Out',
      productStatus: 'Product Status',
    },
    showMsg: {
      title_0: 'Retail price',
      txt_0: 'The original price displayed on the website of the retailers.',
      title_1: 'Price after best discount',
      txt_1:
        'The best price after highest discount displayed on the website and external discounts.',
      title_2: 'On sale price',
      txt_2: 'The discount price offered by the retailers.',
      title_3: 'Retailer dis-price',
      txt_3:
        'The price on top of discount based on ret-price or the estimated actual price on top of discount.',
      title_4: 'Cashback Price',
      txt_4: 'only applicable for Korean retailers.',
      title_6: 'Clearance price',
      txt_6: `Click to only show the price of near-expired product if there is. If there's no near-expired product, the price of normal product will be displayed.`,
      title_5: 'Tax-free price',
      txt_5: `Tick to show the prices after tax refund (only applicable to duty-paid retailers.) For North American retailers, select this price type to show the prices displayed on their website.
      For Japanese retailers, select  this price type to show the prices displayed on the website minus tax refund. `,
    },
  },
  export: {
    priceSavingScale: 'Price Saving Scale',
    priceCategory: 'Price Type',
    date: 'Date',
    priceList: {
      max: 'Max',
      min: 'Min',
      avg: 'Avg',
    },
    table: {
      statusSoldOut: 'Sold Out',
      statusLaunched: 'Launched',
      statusRemoved: 'Removed',
      shopName: 'Shop Name',
      cur: 'Cur.',
      retailPrice: 'Retail Price',
      retp: 'Ret-p({0})',
      promoRate: 'Discount in %',
      optp: 'opt-p({0})',
      indexTo: 'Index to {0}',
      shopNameCurrency: '{0} DF ({1})',
      savingTR: 'Saving TR vs {0}',
      grading: 'Grading',
      status: 'Status',
    },
  },
  //
  helpInfo: {
    help: "The Jessica's Standard price is the price of the product in the Jessica's Standard shop.",
    shop: `Standard Shop：`,
    firstDesc:
      "Standard Shop is a virtual shop based on Jessica’s Secret database. The Standard Shop represents the selection of products for most of the world's shops and the average price of these products.",
    secondDesc: '1.Principle of Product Selection',
    thirdDesc:
      'From all the existing shops covered by Jessica’s Secret database, products that are related to more than 3 shops and sold in no less than 2 countries will be included in the Standard Shop.',
    fourDesc: '2.Principle of Pricing',
    fiveDesc:
      'The product which is chosen by term 1 (priciple of product selection), will be calculated its average price according to all the existing prices offered by the shops.',
  },
};
